import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';
import '@dynamic-labs/multi-wallet';
import '@dynamic-labs/sdk-api';
import '../../../../config/ApiEndpoint.js';
import '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '../../../../context/ViewContext/ViewContext.js';
import '../../../../utils/constants/colors.js';
import '../../../../shared/consts/index.js';
import '../../../../context/DynamicContext/DynamicContext.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import 'react-dom';
import '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import 'react-focus-lock';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../components/IconButton/IconButton.js';
import 'ethers';
import { useKYCFlag } from '../../../../utils/hooks/useKYCFlag/useKYCFlag.js';
import { useMultiWalletFlag } from '../../../../utils/hooks/useMultiWalletFlag/useMultiWalletFlag.js';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { useWidgetContext } from '../../context/DynamicWidgetContext.js';
import { DynamicWidgetSwitcher } from '../DynamicWidgetSwitcher/DynamicWidgetSwitcher.js';
import { DynamicWidgetWalletHeader } from './DynamicWidgetWalletHeader/DynamicWidgetWalletHeader.js';

const DynamicWidgetHeader = () => {
    const { dynamicWidgetView } = useWidgetContext();
    const isKYCEnabled = useKYCFlag();
    const isMultiWalletEnabled = useMultiWalletFlag();
    // Marks 'Profile' view as active when client goes to 'Edit Profile' view
    const dynamicWidgetSwitcherOverwriteValue = useMemo(() => {
        if (!isKYCEnabled && !isMultiWalletEnabled)
            return 'index';
        if (dynamicWidgetView === 'edit-profile')
            return 'profile';
        return dynamicWidgetView;
    }, [dynamicWidgetView, isKYCEnabled, isMultiWalletEnabled]);
    return (jsxs("div", Object.assign({ className: 'dynamic-widget-header' }, { children: [isKYCEnabled && isMultiWalletEnabled && (jsx(DynamicWidgetSwitcher, { overwriteValue: dynamicWidgetSwitcherOverwriteValue })), (dynamicWidgetSwitcherOverwriteValue === 'index' ||
                (dynamicWidgetSwitcherOverwriteValue === 'profile' &&
                    !isMultiWalletEnabled)) && jsx(DynamicWidgetWalletHeader, {})] })));
};
const MemoizedDynamicWidgetHeader = React__default.memo(DynamicWidgetHeader);

export { DynamicWidgetHeader, MemoizedDynamicWidgetHeader, MemoizedDynamicWidgetHeader as default };
